import { useMemo } from "react";
import { generatePath } from "react-router";

import { PATHS } from "@/routes/paths";

import type { QueryData, ViewData } from "../type";
import type { SearchResultTableRowData } from "../type/view-data";

type Props = {
	filteredQueryData: QueryData;
};

type Result = {
	viewData: ViewData;
};

export const useGetViewData = ({ filteredQueryData }: Props): Result => {
	const totalSearchResultCount = useMemo(() => filteredQueryData.length, [filteredQueryData]);
	const totalSalesAmountText = useMemo(() => {
		let amount = 0;

		filteredQueryData.forEach((item) => {
			amount += item.totalGuestCharge;
		});

		return amount.toLocaleString();
	}, [filteredQueryData]);

	const rows = filteredQueryData.map((item) => {
		const hotelID = item.hotelID;
		const receiptID = item.receiptID;
		const detailPagePath = generatePath(PATHS.HOTEL.MANAGEMENT.EC_SALES.DETAIL, { hotelID, ecID: receiptID });

		return {
			hotelID,
			receiptID,

			purchasedItems: item.purchasedItems.map((purchasedItem) => {
				return {
					amount: purchasedItem.amount,
					eachPrice: purchasedItem.eachPrice,
					name: purchasedItem.name,
				};
			}),

			guestName: item.guestName,
			guestNameKana: item.guestNameKana ?? "",
			guestEmail: item.guestEmail,
			guestTel: item.guestTel,
			guestPostalCode: item.guestPostalCode,
			guestAddress: item.guestAddress,

			purchasedDate: item.purchasedDate,
			totalGuestCharge: item.totalGuestCharge,

			detailPagePath,
		} satisfies SearchResultTableRowData;
	}) satisfies SearchResultTableRowData[];

	const viewData = {
		searchResultTableData: {
			rows,
			totalSalesAmountText,
			searchResultCountText: totalSearchResultCount.toLocaleString(),
		},
	} satisfies ViewData;

	return {
		viewData,
	};
};
